module.exports = __webpack_public_path__ + "static/media/effect_button_number.a7c96a94.wav";